import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import AddExperienceSummary from "../../../../Services/ProjectInformationPage/ExperienceSummary/AddExperienceSummary";
import UpdateExperienceSummary from "../../../../Services/ProjectInformationPage/ExperienceSummary/UpdateExperienceSummary";
import {
  GetOneExperienceSummary,
  restValidationExperienceSummary,
  ValidateExperienceSummary,
} from "../../../../Redux/Reducers/ProjectInformationPage/ExperienceSummary/indexOne";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import Swal from "sweetalert2";

const AddEditExperienceSummary = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      OneExperienceSummary: state.OneExperienceSummary.OneExperienceSummary,
      loadingOneExperienceSummary:
        state.OneExperienceSummary.loadingOneExperienceSummary,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships,
      tE_MAinTeamMembersPreviousExperiencePartnershipsId:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships
          .tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        state.tE_MAinTeamMembersPreviousExperiencePartnershipsId
          ?.tE_TeamMembersPreviousExperiencePartnershipsId,
      OneExperienceSummaryValidate:
        state.OneExperienceSummary.OneExperienceSummaryValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  //console.log(
  //   state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
  //   "state"
  // );

  const [ExperienceSummary, setExperienceSummary] = useState({
    tE_PreviousExperienceSummaryId:
      state.OneExperienceSummary?.tE_PreviousExperienceSummaryId,
    projectName: state.OneExperienceSummary?.projectName,
    briefDescriptionOfProject:
      state.OneExperienceSummary?.briefDescriptionOfProject,
    yearOfImplementation: state.OneExperienceSummary?.yearOfImplementation,
    durationOfImplementationInMonths:
      state.OneExperienceSummary?.durationOfImplementationInMonths,
    countryWhereProjectWasImplemented:
      state.OneExperienceSummary?.countryWhereProjectWasImplemented,
    governorateRegion: state.OneExperienceSummary?.governorateRegion,
    nameOfProjectDonor: state.OneExperienceSummary?.nameOfProjectDonor,
    amountOfSupportReceived:
      state.OneExperienceSummary?.amountOfSupportReceived,
    contactPersonFromDonorOrganizationName:
      state.OneExperienceSummary?.contactPersonFromDonorOrganizationName,
    contactInformationEmailPhone:
      state.OneExperienceSummary?.contactInformationEmailPhone,
    tE_TeamMembersPreviousExperiencePartnershipsId:
      state.OneProjectManagementTeamMembers
        ?.tE_TeamMembersPreviousExperiencePartnershipsId,
    tE_MAinTeamMembersPreviousExperiencePartnershipsId:
      state.tE_TeamMembersPreviousExperiencePartnershipsId,
  });

  // const AddSummaryEx = async () => {
  //   await AddExperienceSummary(
  //     ExperienceSummary.projectName,
  //     ExperienceSummary.briefDescriptionOfProject,
  //     ExperienceSummary.yearOfImplementation,
  //     ExperienceSummary.durationOfImplementationInMonths,
  //     ExperienceSummary.countryWhereProjectWasImplemented,
  //     ExperienceSummary.governorateRegion,
  //     ExperienceSummary.nameOfProjectDonor,
  //     ExperienceSummary.amountOfSupportReceived,
  //     ExperienceSummary.contactPersonFromDonorOrganizationName,
  //     ExperienceSummary.contactInformationEmailPhone,
  //     ExperienceSummary.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };

  const numberWithCommas = (x) => {
    //function for formatting numbers with commas
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Function to add new AddSummaryEx

  const AddSummaryEx = async () => {
    const validationList = await dispatch(
      ValidateExperienceSummary({
        projectName: ExperienceSummary.projectName,
        briefDescriptionOfProject: ExperienceSummary.briefDescriptionOfProject,
        yearOfImplementation: ExperienceSummary.yearOfImplementation,
        durationOfImplementationInMonths:
          ExperienceSummary.durationOfImplementationInMonths,
        countryWhereProjectWasImplemented:
          ExperienceSummary.countryWhereProjectWasImplemented,
        governorateRegion: ExperienceSummary.governorateRegion,
        nameOfProjectDonor: ExperienceSummary.nameOfProjectDonor,
        amountOfSupportReceived: ExperienceSummary.amountOfSupportReceived,
        contactPersonFromDonorOrganizationName:
          ExperienceSummary.contactPersonFromDonorOrganizationName,
        contactInformationEmailPhone:
          ExperienceSummary.contactInformationEmailPhone,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");

    if (validationList.payload.length === 0) {
      // If validation passes, add new ExperienceSummary

      await AddExperienceSummary(
        ExperienceSummary.projectName,
        ExperienceSummary.briefDescriptionOfProject,
        ExperienceSummary.yearOfImplementation,
        ExperienceSummary.durationOfImplementationInMonths,
        ExperienceSummary.countryWhereProjectWasImplemented,
        ExperienceSummary.governorateRegion,
        ExperienceSummary.nameOfProjectDonor,
        ExperienceSummary.amountOfSupportReceived,
        ExperienceSummary.contactPersonFromDonorOrganizationName,
        ExperienceSummary.contactInformationEmailPhone,
        ExperienceSummary.tE_TeamMembersPreviousExperiencePartnershipsId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    dispatch(restValidationExperienceSummary());
  }, []);

  // const UpdateSummaryEx = async () => {
  //   await UpdateExperienceSummary(
  //     ExperienceSummary.tE_PreviousExperienceSummaryId,
  //     ExperienceSummary.projectName,
  //     ExperienceSummary.briefDescriptionOfProject,
  //     ExperienceSummary.yearOfImplementation,
  //     ExperienceSummary.durationOfImplementationInMonths,
  //     ExperienceSummary.countryWhereProjectWasImplemented,
  //     ExperienceSummary.governorateRegion,
  //     ExperienceSummary.nameOfProjectDonor,
  //     ExperienceSummary.amountOfSupportReceived,
  //     ExperienceSummary.contactPersonFromDonorOrganizationName,
  //     ExperienceSummary.contactInformationEmailPhone,
  //     ExperienceSummary.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };

  const UpdateSummaryEx = async () => {
    // Function to update existing sponsor data

    const validationList = await dispatch(
      ValidateExperienceSummary({
        projectName: ExperienceSummary.projectName,
        briefDescriptionOfProject: ExperienceSummary.briefDescriptionOfProject,
        yearOfImplementation:
          ExperienceSummary.yearOfImplementation == ""
            ? null
            : ExperienceSummary.yearOfImplementation,
        durationOfImplementationInMonths:
          ExperienceSummary.durationOfImplementationInMonths == ""
            ? null
            : ExperienceSummary.durationOfImplementationInMonths,
        countryWhereProjectWasImplemented:
          ExperienceSummary.countryWhereProjectWasImplemented,
        governorateRegion: ExperienceSummary.governorateRegion,
        nameOfProjectDonor: ExperienceSummary.nameOfProjectDonor,
        amountOfSupportReceived:
          ExperienceSummary.amountOfSupportReceived == ""
            ? null
            : ExperienceSummary.amountOfSupportReceived,
        contactPersonFromDonorOrganizationName:
          ExperienceSummary.contactPersonFromDonorOrganizationName,
        contactInformationEmailPhone:
          ExperienceSummary.contactInformationEmailPhone,
      })
    );
    // If validation passes, update ExperienceSummary

    if (validationList.payload.length === 0) {
      await UpdateExperienceSummary(
        ExperienceSummary.tE_PreviousExperienceSummaryId,
        ExperienceSummary.projectName,
        ExperienceSummary.briefDescriptionOfProject,
        ExperienceSummary.yearOfImplementation,
        ExperienceSummary.durationOfImplementationInMonths,
        ExperienceSummary.countryWhereProjectWasImplemented,
        ExperienceSummary.governorateRegion,
        ExperienceSummary.nameOfProjectDonor,
        ExperienceSummary.amountOfSupportReceived,
        ExperienceSummary.contactPersonFromDonorOrganizationName,
        ExperienceSummary.contactInformationEmailPhone,
        ExperienceSummary.tE_TeamMembersPreviousExperiencePartnershipsId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  // Fetch additional ExperienceSummary data if props are provided
  useEffect(() => {
    if (props != null) {
      dispatch(GetOneExperienceSummary(props.tE_PreviousExperienceSummaryId));
    }
  }, [props.tE_PreviousExperienceSummaryId]);
  useEffect(() => {
    if (!state.loadingOneExperienceSummary && Object.keys(props).length != 0) {
      setExperienceSummary({
        ...state.OneExperienceSummary,
      });
    } else {
      setExperienceSummary({
        projectName: null,
        briefDescriptionOfProject: null,
        yearOfImplementation: null,
        durationOfImplementationInMonths: null,
        countryWhereProjectWasImplemented: null,
        governorateRegion: null,
        nameOfProjectDonor: null,
        amountOfSupportReceived: null,
        contactPersonFromDonorOrganizationName: null,
        contactInformationEmailPhone: null,
        tE_TeamMembersPreviousExperiencePartnershipsId:
          state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      });
    }
  }, [state.OneExperienceSummary]);

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  return (
    <>
      {!state.loadingOneExperienceSummary ? (
        <>
          <div className="AddEdite">
            <TextAreaAHSF
              fieldsName="ProjectName"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  projectName: e.target.value,
                });
              }}
              defaultValue={ExperienceSummary?.projectName}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes("ProjectName")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="BriefAboutTheProject"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  briefDescriptionOfProject: e.target.value,
                });
              }}
              defaultValue={ExperienceSummary?.briefDescriptionOfProject}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "BriefAboutTheProject"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="YearOfImplementation"
              show={true}
              disabled={shouldDisableFields}
              type={"number"}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  yearOfImplementation: e.target.value,
                });
              }}
              defaultValue={state.OneExperienceSummary?.yearOfImplementation}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "YearOfImplementation"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="ImplementationPeriodInMonths"
              show={true}
              disabled={shouldDisableFields}
              type={"number"}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  durationOfImplementationInMonths: e.target.value,
                });
              }}
              defaultValue={
                state.OneExperienceSummary?.durationOfImplementationInMonths
              }
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "ImplementationPeriodInMonths"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="TheCountryInWhichTheProjectWasImplemented"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  countryWhereProjectWasImplemented: e.target.value,
                });
              }}
              defaultValue={
                ExperienceSummary?.countryWhereProjectWasImplemented
              }
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "TheCountryInWhichTheProjectWasImplemented"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="Governorate-Region"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  governorateRegion: e.target.value,
                });
              }}
              defaultValue={ExperienceSummary?.governorateRegion}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "Governorate-Region"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="NameOfTheProjectDonor"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  nameOfProjectDonor: e.target.value,
                });
              }}
              defaultValue={ExperienceSummary?.nameOfProjectDonor}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "NameOfTheProjectDonor"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="TheValueOfTheSupportReceived"
              show={true}
              disabled={shouldDisableFields}
              comma={true}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  amountOfSupportReceived: e.target.value,
                });
              }}
              defaultValue={numberWithCommas(
                state.OneExperienceSummary?.amountOfSupportReceived
              )}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "TheValueOfTheSupportReceived"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <TextAreaAHSF
              fieldsName="RelevantPersonFromTheSupportingEntity"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  contactPersonFromDonorOrganizationName: e.target.value,
                });
              }}
              defaultValue={
                ExperienceSummary?.contactPersonFromDonorOrganizationName
              }
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "RelevantPersonFromTheSupportingEntity"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="ContactInformation"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setExperienceSummary({
                  ...ExperienceSummary,
                  contactInformationEmailPhone: e.target.value,
                });
              }}
              defaultValue={ExperienceSummary?.contactInformationEmailPhone}
              showValidationMessage={
                state.OneExperienceSummaryValidate
                  ? state.OneExperienceSummaryValidate.includes(
                      "ContactInformation"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateSummaryEx()
                        : AddSummaryEx();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneExperienceSummary} />
    </>
  );
};

export default AddEditExperienceSummary;
